var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsActiveOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 44C26.2005 44 28.0005 42.2 28.0005 40H20.0005C20.0005 42.2 21.8005 44 24.0005 44ZM36.0005 32V22C36.0005 15.86 32.7405 10.72 27.0005 9.36V8C27.0005 6.34 25.6605 5 24.0005 5C22.3405 5 21.0005 6.34 21.0005 8V9.36C15.2805 10.72 12.0005 15.84 12.0005 22V32L8.00055 36V38H40.0005V36L36.0005 32ZM32.0005 34H16.0005V22C16.0005 17.04 19.0205 13 24.0005 13C28.9805 13 32.0005 17.04 32.0005 22V34ZM15.1605 8.16L12.3005 5.3C7.50055 8.96 4.34055 14.6 4.06055 21H8.06055C8.36055 15.7 11.0805 11.06 15.1605 8.16ZM39.9405 21H43.9405C43.6405 14.6 40.4805 8.96 35.7005 5.3L32.8605 8.16C36.9005 11.06 39.6405 15.7 39.9405 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActiveOutlined);
export default __webpack_public_path__ + "static/media/notifications-active-outlined.c88edbd069bec3c514c5628f1b3d8d4e.svg";
export { ForwardRef as ReactComponent };